import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { legalArticleSlugs } from './country.config';
import { CountryContext } from './country-context.service';

/**
 * Route guard for /article/:article.
 *
 * CMS articles are Swedish content, so SE resolves every slug. A non-SE market
 * resolves only the eight legal articles authored in its own language, listed in
 * LEGAL_ARTICLES (country.config.ts) alongside the labels its footer renders.
 * Any other slug keeps the previous behaviour and redirects to /.
 *
 * Slugs are globally unique, so a market's own list is the only membership test
 * needed: DK cannot reach a DE slug because that slug is not in DK's list.
 */
export const legalArticleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const country = inject(CountryContext).country;
  if (country === 'SE') return true;

  const slug = route.paramMap.get('article');
  if (slug !== null && legalArticleSlugs(country).has(slug)) return true;

  return inject(Router).createUrlTree(['/']);
};
